module.exports = __webpack_public_path__ + "img/myvhis-logo-white.94c70abc.png";